/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import { randomGetRandomImage } from "../../funcs/randomGetRandomImage.js";
import { GetRandomImageRequest$zodSchema } from "../../models/getrandomimageop.js";
import { formatResult, ToolDefinition } from "../tools.js";

const args = {
  request: GetRandomImageRequest$zodSchema.optional(),
};

export const tool$randomGetRandomImage: ToolDefinition<typeof args> = {
  name: "random-get-random-image",
  description: `随机图片

需要一张随机图片作为占位符或者背景吗？这个接口是你的不二之选。

## 功能概述
这是一个非常简单的接口，它会从我们庞大的图库和精选外部图床中随机挑选一张图片，然后通过 302 重定向让你直接访问到它。这使得它可以非常方便地直接用在 HTML 的 \`<img>\` 标签中。

你可以通过 \`/api/v1/random/image?category=acg&type=4k\` 这样的请求获取由UapiPro服务器提供的图片，也可以通过 \`/api/v1/random/image?category=ai_drawing\` 获取由外部图床精选的图片。

如果你不提供任何 category 参数，程序会从所有图片（包括本地的和URL的）中随机抽取一张（**全局随机图片不包含ikun和AI绘画**）。

> [!TIP]
> 如果你需要更精确地控制图片类型，请使用 \`/image/random/{category}/{type}\` 接口。

### 支持的主类别与子类别
- **acg**（二次元动漫）


    - pc
    - mb
- **外部图床精选/混合动漫**


  - **landscape**: 风景图。
  - **anime**: 混合了UapiPro服务器的acg和外部图床的general_anime分类下的图片。
  - **pc_wallpaper**: 电脑壁纸。
  - **mobile_wallpaper**: 手机壁纸。
  - **general_anime**: 动漫图。
  - **ai_drawing**: AI绘画。
- **其他分类**


  - **bq**（表情包/趣图）
    - eciyuan
    - ikun
    - xiongmao
    - waiguoren
    - maomao
  - **furry**（福瑞）
    - z4k
    - szs8k
    - s4k
    - 4k

> [!NOTE]
> 默认全局随机（未指定category参数）时，不会包含ikun和AI绘画（ai_drawing）类别的图片。
`,
  scopes: ["read"],
  annotations: {
    "title": "",
    "destructiveHint": false,
    "idempotentHint": false,
    "openWorldHint": true,
    "readOnlyHint": true,
  },
  args,
  tool: async (client, args, ctx) => {
    const [result] = await randomGetRandomImage(
      client,
      args.request,
      { fetchOptions: { signal: ctx.signal } },
    ).$inspect();

    if (!result.ok) {
      return {
        content: [{ type: "text", text: result.error.message }],
        isError: true,
      };
    }

    return formatResult(result.value);
  },
};
